import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Image } from 'foundations-components/transitional/components/Image';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionPreviewThumbnails({
  previewItems,
  totalItemCount,
  maxThumbnails = 3,
  onCollectionClick
}) {
  const visibleItems = previewItems.slice(0, maxThumbnails);
  const remainingCount = Math.max(0, totalItemCount - maxThumbnails);
  if (visibleItems.length === 0) {
    return null;
  }
  const content = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexShrink: 0,
    children: [visibleItems.map((item, index) => /*#__PURE__*/_jsx(Tooltip, {
      title: item.name,
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-surface-recessed",
        padding: "200",
        borderRadius: "full",
        borderWidth: "100",
        borderStyle: "solid",
        borderColor: "fill-surface-default",
        marginInlineStart: index > 0 ? '-200' : '0',
        children: /*#__PURE__*/_jsx(Image, {
          src: item.iconUrl || '',
          alt: item.name || 'App icon',
          blockSize: "20px",
          inlineSize: "20px"
        })
      })
    }, item.listingId)), remainingCount > 0 && /*#__PURE__*/_jsx(Flex, {
      backgroundColor: "fill-surface-recessed",
      padding: "200",
      borderRadius: "full",
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "fill-surface-default",
      marginInlineStart: "-200",
      alignItems: "center",
      justifyContent: "center",
      blockSize: "40px",
      inlineSize: "40px",
      children: /*#__PURE__*/_jsxs(Text, {
        color: "text-core-default",
        typography: "detail-100",
        children: ["+", remainingCount]
      })
    })]
  });
  if (onCollectionClick) {
    return /*#__PURE__*/_jsx(Clickable, {
      onClick: onCollectionClick,
      children: content
    });
  }
  return content;
}